import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
export type QuizPlayerMtfComponentFragment = { leftElements: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }>, distractedRightElements?: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null };


export type QuizPlayerMtfComponentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type QuizPlayerFtbComponentFragment = { text?: string | null, isBlank: boolean, id: string, distractors?: Array<{ text: string }> | null };


export type QuizPlayerFtbComponentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type QuizPlayerImageHotspotComponentFragment = { text?: string | null, id: string, x: number, y: number, distractors?: Array<{ text: string }> | null };


export type QuizPlayerImageHotspotComponentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type QuizPlayerQuestionContentFragment = { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum, subType?: Types.QuestionSubTypeEnum | null, correctAnswerFeedback?: string | null, incorrectAnswerFeedback?: string | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, options?: Array<{ optionId: string, optionText: string, optionRelativeScore?: number | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null, mtfComponent?: { leftElements: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }>, distractedRightElements?: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null } | null, ftbComponents: Array<{ text?: string | null, isBlank: boolean, id: string, distractors?: Array<{ text: string }> | null }>, imageHotspotComponents: Array<{ text?: string | null, id: string, x: number, y: number, distractors?: Array<{ text: string }> | null }>, globalDistractedOptions: Array<{ id: string, text: string }>, associations: Array<{ entityAssociation: { lessonId: string, lessonPageId?: string | null } }> };


export type QuizPlayerQuestionContentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizPlayerMtfComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizPlayerMTFComponent on MTFComponent {
  leftElements {
    text
    id
    attachments {
      ...EntityMedia
    }
  }
  distractedRightElements {
    text
    id
    attachments {
      ...EntityMedia
    }
  }
}
    `;
export const QuizPlayerFtbComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizPlayerFTBComponent on FTBComponent {
  text
  distractors {
    text
  }
  isBlank
  id
}
    `;
export const QuizPlayerImageHotspotComponentFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizPlayerImageHotspotComponent on ImageHotspotComponent {
  text
  distractors {
    text
  }
  id
  x
  y
}
    `;
export const QuizPlayerQuestionContentFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizPlayerQuestionContent on QuestionType {
  id
  questionText
  questionType
  subType
  attachments {
    ...EntityMedia
  }
  options(shuffleOptions: true) {
    optionId
    optionText
    optionRelativeScore
    attachments {
      ...EntityMedia
    }
  }
  mtfComponent {
    ...QuizPlayerMTFComponent
  }
  ftbComponents {
    ...QuizPlayerFTBComponent
  }
  imageHotspotComponents {
    ...QuizPlayerImageHotspotComponent
  }
  globalDistractedOptions {
    id
    text
  }
  correctAnswerFeedback
  incorrectAnswerFeedback
  associations {
    entityAssociation {
      lessonId
      lessonPageId
    }
  }
}
    `;